export default "__VITE_ASSET__Bn8__ZPE__"